<template lang="pug">
  .landing
    v-dialog(v-model="loader" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | Cargando asistencias...
            v-progress-linear.mb-0(indeterminate="" color="white")
    //- .g-overlay-2(v-show="overlay2")
    //- .g-overlay(v-show="overlay")
    //- .modal-codigo.modal-asistencia(v-show="modalCodigo" style="position: fixed; top: 150px;")
      figure
        img(src="../assets/landing/descuentos/img-perfil.png" width="100" height="auto")
      h3(style="color: #0855C4;") Contáctanos
      p.mt-3(style="color:#000; font-size: 14px;")
        | Comuníquese con Servicio de Atención al Cliente:
        strong  {{ codeCopy }}
      button(@click="closeModalCodigo") Ok
    //- .modal-detalle(v-show="modalDetalle")
      .modal-detalle-content
        .modal-detalle-close
          svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg", @click="closeModalDetalle")
            path(d="M18 6L6 18" stroke="#0855C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
            path(d="M6 6L18 18" stroke="#0855C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
        .col-1.plr-25
          figure.text-xs-center.modal-img-desktop
            img(style="border-radius: 10px; width: 92%;" :src="selectedItem.img")
          figure.text-xs-center.modal-img-mobile
            img(style="border-radius: 10px; width: 92%;" :src="selectedItem.miniature")
          .btn-favorito(:id="'favorite-' + selectedItem.id" :class="(selectedItem.favorite)?'filled':''" @click="editFavorites(selectedItem, true)")
            svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M7 3C4.239 3 2 5.216 2 7.95C2 10.157 2.875 15.395 11.488 20.69C11.6423 20.7839 11.8194 20.8335 12 20.8335C12.1806 20.8335 12.3577 20.7839 12.512 20.69C21.125 15.395 22 10.157 22 7.95C22 5.216 19.761 3 17 3C14.239 3 12 6 12 6C12 6 9.761 3 7 3Z" stroke="#919191" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
            p Agrega a tus favoritos
        .col-2.modal-content-responsive(style="background: #FFF;")
          div(style="padding-right: 4px;")
            .mt-4.modal-content-data
              .modal-detalle-asistencia-title
                h3(:id="'title-' + selectedItem.id") {{selectedItem.name}}
                .g-flex.justify-space-between.align-center.mt-3.tooltip-payment-type
                  p.mb-0 {{getPaymentType(selectedItem.payment_type)}}
                  .g-flex.align-center
                    strong {{ selectedItem.value }}
                    v-tooltip(bottom style="z-index: 112 !important;")
                      template(v-slot:activator='{ on, attrs }')
                        svg(viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" v-bind="attrs" v-on="on")
                          path(v-if="selectedItem.payment_type ==='copago'" d="M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z" fill="#D0D6E0")
                          path(v-if="selectedItem.payment_type ==='copago'" d="M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z" fill="white")
                      span.tooltip-poput(style="color:#FFF;") Una pequeña cantidad<br>de dinero que deberás<br>pagar al usar el servicio
                .g-flex.justify-space-between.align-center.mt-3.tooltip-limit
                  p.mb-0 Límite anual
                  .g-flex.align-center
                    strong {{ (selectedItem.annual_limit === 0)? 'Sin límite' : `${selectedItem.annual_limit} evento${selectedItem.annual_limit === 1 ? '':'s'}` }}
                    v-tooltip(bottom style="z-index: 112 !important;")
                      template(v-slot:activator='{ on, attrs }')
                        svg(viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" v-bind="attrs" v-on="on")
                          path(d="M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z" fill="#D0D6E0")
                          path(d="M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z" fill="white")
                      span.tooltip-poput(style="color:#FFF;") Uso máximo por año
              .modal-detalle-item
                .modal-detalle-item-title.py-2
                  h4 {{selectedItem.subtitle}}
                .modal-detalle-item-content.plr-25
                  p.mt-3(style="width: 100%;" v-html="selectedItem.description")
              .modal-detalle-toggle
                .modal-detalle-item(v-if="selectedItem && selectedItem.items.length > 0")
                  .modal-detalle-item-title.pt-3.pb-2.g-flex.align-center.justify-space-between(@click="openService")
                    h4 {{selectedItem.items_title}}
                    svg(width="7" height="12" viewBox="0 0 7 12" fill="none", :class="{'arrow-bottom': activeArrow1}",  xmlns="http://www.w3.org/2000/svg")
                      path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")
                  .modal-detalle-item-content.plr-25(v-show="showService")
                    .modal-detalle-item-content.plr-25(v-show="showService")
                    .g-flex.mt-3(v-if="selectedItem && selectedItem.items.length > 0" v-for="(item, index) in selectedItem.items", :key="index")
                      figure.mt-1
                        img(:src="(selectedItem?item.img:'')")
                      p.text-restri.mb-0(v-html="selectedItem?item.code:''")
                .modal-detalle-item(style="padding-bottom: 60px;" v-if="selectedItem && selectedItem.rules.length > 0")
                  .modal-detalle-item-title.pt-3.pb-2.g-flex.align-center.justify-space-between(@click="openInfo")
                    h4  {{selectedItem.rules_title}}
                    svg(width="7" height="12" viewBox="0 0 7 12" fill="none", :class="{'arrow-bottom': activeArrow2}",  xmlns="http://www.w3.org/2000/svg")
                      path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")
                  .modal-detalle-item-content.plr-25(v-show="showInfo")
                    .g-flex.align-center.mt-3(v-if="selectedItem && selectedItem.rules.length > 0" v-for="(item, index) in selectedItem.rules", :key="index")
                      figure.mt-1
                        img(:src="(selectedItem?item.img:'')")
                      p.text-restri.mb-0(v-html="selectedItem?item.code:''")
                .modal-detalle-btn.modal-detalle-btn-mobile(v-if="primary")
                  button(:id="'action1-' + selectedItem.id" @click="actionExecute(primary,selectedItem)") {{ primary.title }}
              .modal-detalle-btn.modal-detalle-btn-desktop(v-if="primary")
                button(:id="'action1-' + selectedItem.id" @click="actionExecute(primary,selectedItem)") Solicitar asistencia
    section
      v-container
        .d-lg-flex
          .landing-navigation.d-inline-flex.align-center
            figure(@click="goToHome" style="cursor: pointer;")
              img(src="../assets/landing/icon-home.png", alt="imagen del home")
            .d-flex.align-center(v-for="(item, index) in menuNav", :key="index" @click="goToPath(item.path, item.option);" style="cursor: pointer;")
                svg(width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg")
                  path(d="M0.310022 0.710022C0.217319 0.802536 0.143771 0.912424 0.0935898 1.0334C0.0434083 1.15437 0.0175781 1.28405 0.0175781 1.41502C0.0175781 1.54599 0.0434083 1.67567 0.0935898 1.79665C0.143771 1.91762 0.217319 2.02751 0.310022 2.12002L4.19002 6.00002L0.310022 9.88002C0.123045 10.067 0.0180016 10.3206 0.0180016 10.585C0.0180016 10.8494 0.123045 11.103 0.310022 11.29C0.497 11.477 0.750596 11.582 1.01502 11.582C1.27945 11.582 1.53304 11.477 1.72002 11.29L6.31002 6.70002C6.40273 6.60751 6.47627 6.49762 6.52646 6.37665C6.57664 6.25567 6.60247 6.12599 6.60247 5.99502C6.60247 5.86405 6.57664 5.73437 6.52646 5.6134C6.47627 5.49242 6.40273 5.38253 6.31002 5.29002L1.72002 0.700022C1.34002 0.320022 0.700022 0.320022 0.310022 0.710022Z" fill="#0855C4")
                p(:class="{'active-nav': item.active}") {{item.name}}
          .landing-search.mt-3.mt-lg-0
            svg(width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M28.5435 28.5442C28.4783 28.6094 28.401 28.661 28.3159 28.6963C28.2308 28.7315 28.1396 28.7497 28.0475 28.7497C27.9554 28.7497 27.8642 28.7315 27.7791 28.6963C27.694 28.661 27.6167 28.6094 27.5516 28.5442L22.3454 23.3382C20.2881 25.1376 17.612 26.0671 14.8822 25.9302C12.1524 25.7933 9.58269 24.6009 7.7157 22.6047C5.84871 20.6085 4.83063 17.9648 4.87648 15.232C4.92233 12.4992 6.02852 9.89114 7.96142 7.95869C9.89432 6.02624 12.5026 4.92067 15.2355 4.87547C17.9683 4.83026 20.6117 5.84896 22.6075 7.71642C24.6033 9.58388 25.7951 12.1539 25.9313 14.8837C26.0675 17.6135 25.1374 20.2894 23.3375 22.3463L28.5435 27.5523C28.6086 27.6174 28.6603 27.6947 28.6956 27.7798C28.7309 27.865 28.749 27.9562 28.749 28.0483C28.749 28.1404 28.7309 28.2317 28.6956 28.3168C28.6603 28.4019 28.6086 28.4791 28.5435 28.5442ZM15.422 24.5409C17.2256 24.5409 18.9886 24.0061 20.4882 23.0041C21.9878 22.0021 23.1566 20.5779 23.8468 18.9117C24.537 17.2454 24.7176 15.4119 24.3657 13.643C24.0139 11.8741 23.1454 10.2492 21.8701 8.97394C20.5948 7.69863 18.9699 6.83014 17.201 6.47828C15.4321 6.12643 13.5986 6.30701 11.9324 6.9972C10.2661 7.68739 8.84192 8.85619 7.83992 10.3558C6.83792 11.8554 6.30311 13.6184 6.30311 15.422C6.30583 17.8396 7.26745 20.1575 8.97699 21.867C10.6865 23.5766 13.0044 24.5382 15.422 24.5409Z" fill="#0855C4")
            input(type="text" placeholder="Busca lo que necesites" v-on:keyup="filterData($event, categoryTitle)")

    section
      v-container
        .d-flex.landing-detail-nav
          .effect-scale(v-for="item in categories" :key="item.id")
            article(@click="goToPath('', item.name);gtmChangeCategory(item.name)" :class="(item.name === categoryTitle)?'selected-box':''")
              figure
                img(:src="item.img" height="38" width="42")
              figcaption {{item.name}}
    section
      v-container
        h2 {{categoryTitle}}
        div 
          CardsPromotion(:url="getUrl" :query="parametros" :saveGTM="switchAction" v-if="loaded")
        //- .d-flex.g-flex-wrap
          .col(v-for="item in dataAssists", :key="item.id")
            article.card(:id="'card-' + item.id")
              figure(:id="'favorite-' + item.id")
                img(:src="item.miniature" style="height: 125px;")
                .card-heart(@click="editFavorites(item)")
                  v-icon(:class="item.favorite?'filled':''") {{item.favorite? 'favorite':'favorite_border'}}
              div.card-content.list-card-asistencias
                h3(:id="'title-' + item.id" style="display: flex;align-items: center;") {{item.name}}
                .g-flex.justify-space-between.align-center.mt-3
                  p.mb-0 {{getPaymentType(item.payment_type)}}
                  .g-flex.align-center
                    strong {{item.value}}
                    v-tooltip(bottom)
                      template(v-slot:activator='{ on, attrs }')
                        svg(width="12" height="12" viewbox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind="attrs" v-on="on")
                          path(v-if="item.payment_type ==='copago'" d='M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z', fill='#D0D6E0')
                          path(v-if="item.payment_type ==='copago'" d='M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z', fill='white')
                      span(style="color:#FFF;") Una pequeña cantidad<br>de dinero que deberás<br>pagar al usar el servicio
                .g-flex.justify-space-between.align-center.mt-3
                  p.mb-0 Límite anual
                  .g-flex.align-center
                    strong {{ (item.annual_limit === 0)? 'Sin límite' : `${item.annual_limit} evento${item.annual_limit === 1 ? '':'s'}` }}
                    v-tooltip(bottom)
                      template(v-slot:activator='{ on, attrs }')
                        svg(width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind="attrs" v-on="on")
                          path(d="M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z" fill="#D0D6E0")
                          path(d="M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z" fill="white")
                      span(style="color:#FFF;") Uso máximo por año
                button.mt-4.g-btn-purple(@click="openModalDetalle(item)") Detalles
          .col(v-for="item in ((dataAssists.length % 4 === 0) ? 0: 4 - (dataAssists.length % 4) )", :key="item")
            article.card(style="border:none; box-shadow: none;")
        //- a.ver-mas.g-btn-purple(@click="nextData()" v-if="(page*limit < counter)") Ver más
    section.landing-bottom
      v-container
        v-carousel.landing-bottom-list.landing-bottom-carousel.landing-bottom-mobile
          v-carousel-item
            article.g-flex.g-align-center
              figure
                img(src="../assets/landing/icon-descuentos.png" alt="imagen de descuentos")
              div
                h5 Descuentos
                p Descubre todos los productos y servicios que tenemos  para tí
          v-carousel-item
            article.g-flex.g-align-center
              figure
                img(src="../assets/landing/icon-cerca-ti.png" alt="imagen de cerca de tí")
              div
                h5 Cerca de tí
                p Proveedores en distintos distritos de lima y provincia
          v-carousel-item
            article.g-flex.g-align-center
              figure
                img(src="../assets/landing/icon-calidad.png" alt="imagen de calidad")
              div
                h5 Calidad de marcas
                p Nuestros proveedores son marcas reconocidas y de buena calidad en sus productos
        v-layout(row wrap align-center).landing-bottom-list.landing-bottom-desktop
          v-flex(lg4)
            article.g-flex.g-align-center
              figure
                img(src="../assets/landing/icon-descuentos.png" alt="imagen de descuentos")
              div
                h5 Descuentos
                p Descubre todos los productos y servicios que tenemos  para tí
          v-flex(lg4)
            article.g-flex.g-align-center
              figure
                img(src="../assets/landing/icon-cerca-ti.png" alt="imagen de cerca de tí")
              div
                h5 Cerca de tí
                p Proveedores en distintos distritos de lima y provincia
          v-flex(lg4)
            article.g-flex.g-align-center
              figure
                img(src="../assets/landing/icon-calidad.png" alt="imagen de calidad")
              div
                h5 Calidad de marcas
                p Nuestros proveedores son marcas reconocidas y de buena calidad en sus productos

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Navigation from '@/components/LandingNavig.vue'
import CardsPromotion from 'is-card-benefit/src/components/CardsPromotion.vue'
export default{
  props: ['category'],
  components: {
    Navigation,
    CardsPromotion
  },
  data: () => ({
    // PENDIENTE: vivemas-backend no tiene /assists (antes /vivemas/v1.0/assists, que ya respondía 404); Apigee también responde 404
    getUrl: process.env.API_VIVEMAS + '/assists',
    parametros: {},
    loaded: false,
    //- isMobile: true,
    categories: [],
    categoryTitle: '',
    brand: '',
    loader: false,
    menuNavBase: [
      {
        active: false,
        name: 'Beneficios Vive+',
        path: '/vivemas',
        option: ''
      },
      {
        active: false,
        name: 'Asistencias',
        path: '/vivemas-asistencias',
        option: ''
      }
    ],
    menuNav: [],
    //- dataAssists: [],
    //- modalDetalle: false,
    //- modalCodigo: false,
    //- showService: false,
    //- showInfo: false,
    //- overlay: false,
    //- overlay2: false,
    //- activeArrow1: false,
    //- activeArrow2: false,
    //- selectedItem: {
    //-   id: '',
    //-   name: '',
    //-   payment_type: '',
    //-   value: '',
    //-   subtitle: '',
    //-   description: '',
    //-   img: '',
    //-   category: '',
    //-   ordinal: 1,
    //-   brand: {
    //-     img: '',
    //-     name: ''
    //-   },
      //- first_action: {},
      //- second_action: {},
      //- items_title: '',
      //- items: [{ img: '', code: '' }],
      //- rules_title: '',
      //- rules: [{ img: '', code: '' }],
      //- visits: '',
      //- stars: '',
      //- favorite: false
    //- },
    //- primary: {action: () => {}, title: '', value: ''},
    //- secondary: {action: () => {}, title: '', value: ''},
    //- codeCopy: '',
    skip: 0,
    limit: 1000,
    counter: 0,
    page: 1,
    search: '',
    isOnlySoat: false,
    productsArray: [],
    searchPersistent: '',
    searchValidate: false
  }),
  mounted () {
    //- if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    //-   this.isMobile = true
    //- } else {
    //-   this.isMobile = false
    //- }
    this.categoryTitle = this.$route.query.category
    this.menuNav = []
    this.menuNav.push(...this.menuNavBase)
    if (this.categoryTitle && this.categoryTitle !== '') {
      this.menuNav.push({
        active: true,
        name: this.categoryTitle,
        path: '/vivemas-asistencias?category=' + this.categoryTitle,
        option: this.categoryTitle
      })
      this.gtmSend(this.categoryTitle)
    } else {
      this.menuNav = this.menuNav.map(opt => {
        opt.active = opt.name === 'Beneficios Vive+'
        return opt
      })
    }
    //- this.dataAssists = []
    
    this.categories = this.assistCategories || []
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    }
    fetch(process.env.API_VIVEMAS + '/categories/assists', requestOptions)
      .then(response => response.json())
      .then(data => {
        this.$store.commit('vivemas/setAssistCategories', data.data)
        this.categories = data.data
      })
      .catch(error => console.error('Error getAssistsCategories: ',error));
    //- this.getAssistsCategories().then(res => {
    //-   this.$store.commit('vivemas/setAssistCategories', res.data.data)
    //-   this.categories = res.data.data
    //- }).catch(err => {
    //- })
    this.getBenefitsCallback()
  },
  methods: {
    ...mapActions('vivemas', ['getAssistsCategories', 'getAssists', 'editFavorite']),
    ...mapActions('event', ['eventLog']),
    //- closeModalCodigo () {
    //-   document.getElementsByTagName('html')[0].style.overflowY = 'scroll'
    //-   this.overlay2 = false
    //-   this.modalCodigo = false
    //-   this.modalDetalle = false
    //- },
    //- closeModalDetalle () {
    //-   document.getElementsByTagName('html')[0].style.overflowY = 'scroll'
    //-   this.modalDetalle = false
    //-   this.overlay = false
    //- },
    //- openModalDetalle (item) {
    //-   document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
    //-   this.primary = this.switchAction(item.first_action)
    //-   this.secondary = this.switchAction(item.second_action)
    //-   this.selectedItem = item
    //-   this.modalDetalle = true
    //-   this.overlay = true
    //-   this.showService = false
    //-   this.showInfo = false
    //-   this.activeArrow1 = false
    //-   this.activeArrow2 = false
    //-   this.$amplitude.getInstance()
    //-     .logEvent('Selección del Beneficio', {'Tipo de Beneficio': 'Asistencias', 'Categoria': this.categoryTitle, 'Beneficio': item.name, 'Canal de consulta': 'Zona Segura'})
    //-   this.gtmSelectDetails(this.categoryTitle, item)
    //-   // ZS Analytics
    //-   this.eventLog({
    //-     categoria: 'Vivemas',
    //-     nombre: 'Selección de Asistencia',
    //-     datos: {tipoBeneficio: 'Asistencias', Categoria: this.categoryTitle || '', Beneficio: item.name}
    //-   })
    //-   if (this.searchValidate) {
    //-   // EVENTO - 54 - Elemento - Seleccionar resultado de búsqueda - Analytics
    //-     this.$gtm.trackEvent({
    //-       'event': 'virtualEvent',
    //-       'category': 'Zona Segura',
    //-       'action': 'Vive+ - Asistencias',
    //-       'label': 'Buscador - Seleccionar resultado - ' + item.name
    //-     })
    //-     this.$gtm.trackEvent({
    //-       'event': 'select_button',
    //-       'Nombre Sección': 'Zona Segura',
    //-       'TipoElemento': 'Botón',
    //-       'TipoAccion': 'Vive+ - Asistencias',
    //-       'CTA': 'Buscador - Seleccionar resultado - ' + item.name,
    //-       'keyword': this.searchPersistent
    //-     })
    //-   }
    //- },
    //- openService () {
    //-   this.showService = !this.showService
    //-   this.activeArrow1 = !this.activeArrow1
    //- },
    //- openInfo () {
    //-   this.showInfo = !this.showInfo
    //-   this.activeArrow2 = !this.activeArrow2
    //- },
    //- openModalCodigo () {
    //-   this.overlay = false
    //-   if (this.isMobile) {
    //-     var link = document.createElement('a')
    //-     link.href = 'tel:' + this.codeCopy.toLowerCase().split('opción')[0].split('opcion')[0].trim()
    //-     link.click()
    //-   } else {
    //-     this.overlay2 = true
    //-     this.modalCodigo = true
    //-     this.codeCopy = this.codeCopy
    //-   }
    //- },
    //- actionExecute (action, item = '') {
    //-   if (action) {
    //-     action.action()
    //-   }

    //-   // EVENT - 58 -Elemento - Solicitar Asistencia - Analytics
    //-   this.$gtm.trackEvent({
    //-     'event': 'virtualEvent',
    //-     'category': 'Zona Segura',
    //-     'action': 'Vive+ - Asistencias - ' + item.category,
    //-     'label': item.name + ' - Solicitar Asistencia'
    //-   })

    //-   this.$gtm.trackEvent({
    //-     'event': 'select_button',
    //-     'Nombre Sección': 'Zona Segura',
    //-     'TipoElemento': 'Botón',
    //-     'TipoAccion': 'Vive+ - Asistencias - ' + item.category,
    //-     'CTA': item.name + ' - Solicitar Asistencia'
    //-   })
    //- },
    //- switchAction (action) {
    //-   let self = this
    //-   if (action && action !== null) {
    //-     let funcAction = () => {}
    //-     switch (action.type) {
    //-     case 'copy':
    //-       funcAction = () => {
    //-         self.codeCopy = action.value
    //-         let aux = document.createElement('input')
    //-         aux.setAttribute('value', action.value)
    //-         document.body.appendChild(aux)
    //-         aux.select()
    //-         document.execCommand('copy')
    //-         document.body.removeChild(aux)
    //-         self.openModalCodigo()
    //-         //- self.$amplitude.getInstance()
    //-           //- .logEvent('Copiar código', {'Categoria': self.categoryTitle, 'Beneficio': self.selectedItem.name, 'Detalle del beneficio': 'Obtener código', 'Canal de consulta': 'Zona Segura'})
    //-         // ZS Analytics
    //-         //- self.eventLog({
    //-         //-   categoria: 'Vivemas',
    //-         //-   nombre: 'Selección del Beneficio',
    //-         //-   datos: {tipoBeneficio: 'Asistencias', Categoria: self.categoryTitle || '', Beneficio: self.selectedItem.name, 'Acción': 'Obtener código'}
    //-         //- })
    //-       }
    //-       return {action: funcAction, title: 'Copiar código', value: action.value}
    //-     case 'call':
    //-       funcAction = () => {
    //-         let telephone = action.value.toLowerCase().split('opción')[0].split('opcion')[0].trim()
    //-         if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    //-           self.isMobile = true
    //-           let link = document.createElement('a')
    //-           link.href = 'tel:' + telephone
    //-           link.click()
    //-         } else {
    //-           self.isMobile = false
    //-           self.codeCopy = action.value
    //-           self.openModalCodigo()
    //-           self.callModal = true
    //-         }
    //-         self.$amplitude.getInstance()
    //-           .logEvent('Copiar código', {'Categoria': self.categoryTitle, 'Beneficio': self.selectedItem.name, 'Detalle del beneficio': 'LLamada', 'Canal de consulta': 'Zona Segura'})
    //-         // ZS Analytics
    //-         self.eventLog({
    //-           categoria: 'Vivemas',
    //-           nombre: 'Selección del Beneficio',
    //-           datos: {tipoBeneficio: 'Asistencias', Categoria: self.categoryTitle || '', Beneficio: self.selectedItem.name, 'Acción': 'Realizar llamada'}
    //-         })
    //-       }
    //-       return {action: funcAction, title: 'Obtener Asistencia', value: action.value}
    //-     case 'email':
    //-       funcAction = () => {
    //-         self.$amplitude.getInstance()
    //-           .logEvent('Copiar código', {'Categoria': self.categoryTitle, 'Beneficio': self.selectedItem.name, 'Detalle del beneficio': 'Enviar correo', 'Canal de consulta': 'Zona Segura'})
    //-         // ZS Analytics
    //-         self.eventLog({
    //-           categoria: 'Vivemas',
    //-           nombre: 'Selección del Beneficio',
    //-           datos: {tipoBeneficio: 'Asistencias', Categoria: self.categoryTitle || '', Beneficio: self.selectedItem.name, 'Acción': 'Enviar correo'}
    //-         })
    //-         if (this.isMobile) {
    //-           var link = document.createElement('a')
    //-           link.href = 'mailto::' + action.value
    //-           link.click()
    //-         } else {
    //-           this.overlay2 = true
    //-           this.codeCopy = action.value
    //-           this.modalCall = true
    //-         }
    //-       }
    //-       return {action: funcAction, title: 'Solicitar asistencia', value: action.value}
    //-     default: return null
    //-     }
    //-   }
    //-   return null
    //- },
    //- editFavorites (item, openDetail) {
    //-   let aux = !item.favorite
    //-   this.dataAssists = this.dataAssists.map(assist => {
    //-     if (assist.id === item.id) {
    //-       assist.favorite = aux
    //-     }
    //-     return assist
    //-   })
    //-   this.eventLog({
    //-     categoria: 'Vivemas',
    //-     nombre: 'Modificar favoritos',
    //-     datos: {'Categoria': this.categoryTitle || '', 'Beneficio': this.selectedItem.brand.name + ' - ' + this.selectedItem.subtitle, 'Acción': aux ? 'Agregar a favoritos' : 'Eliminar de favoritos'}
    //-   })
    //-   this.editFavorite('assists', {id: item.id, favorite: aux}).then(() => {
    //-     // ZS Analytics
    //-     if (aux) {
    //-       this.$amplitude.getInstance()
    //-         .logEvent('Agrega a tus favoritos', {'Categoria': this.categoryTitle, 'Beneficio': this.selectedItem.name, 'Canal de consulta': 'Zona Segura'})
    //-       // EVENT - 57 - Elemento - Agrega a tus Favoritos - Analytics
    //-       let categoryTitle
    //-       if (this.categoryTitle === undefined || this.categoryTitle === '') {
    //-         categoryTitle = 'Asistencias'
    //-       } else {
    //-         categoryTitle = 'Asistencias - ' + this.categoryTitle
    //-       }
    //-       this.$gtm.trackEvent({
    //-         'event': 'virtualEvent',
    //-         'category': 'Zona Segura',
    //-         'action': 'Vive+ - ' + categoryTitle,
    //-         'label': item.name + ' - Agrega a tus favoritos'
    //-       })

    //-       this.$gtm.trackEvent({
    //-         'event': 'select_button',
    //-         'Nombre Sección': 'Zona Segura',
    //-         'TipoElemento': 'Botón',
    //-         'TipoAccion': 'Vive+ - ' + categoryTitle,
    //-         'CTA': item.name + ' - Agrega a tus favoritos'
    //-       })
    //-     }
    //-   }).catch(() => {})
    //- },
    switchAction (UAT, GA4) {
      this.registerGTM(UAT, GA4)
    },
    getBenefitsCallback (searchAnalytics = '') {
      const req = {};
      req.skip = this.skip
      req.limit = this.limit
      // console.log('getBenefitsCallback: ', this.categoryTitle);

      const brand = this.brand;
      const search = this.search;
      const categoryTitle = this.categoryTitle;
      const numeroDocumento = this.basicInfo.numeroDocumento;
      const cityName = '';
      if (brand !== '') {
        req.brand = brand;
      }

      if (search !== '') {
        req.search = search;
      } else if (categoryTitle && categoryTitle !== '') {
        req.category = categoryTitle;

      }

      if (numeroDocumento) {
        req.numeroDocumento = numeroDocumento;
      }

      if (cityName !== 'Todos' && cityName !== '') {
        req.city = cityName;
      }
      this.parametros = req
      this.loaded = true
      //- req.skip = this.skip
      //- req.limit = this.limit
      //- this.loader = true
      //- this.getAssists(req).then(res => {
      //-   this.counter = res.data.data.counter || 0
      //-   this.dataAssists.push(...(res.data.data.rows || []))
      //-   this.loader = false
      //-   this.search = ''
      //-   this.searchPersistent = req.search
      //-   this.searchValidate = false
      //-   if (searchAnalytics) {
      //-     this.sendSearchAnalytics(this.counter, req.search)
      //-     this.searchValidate = true
      //-   }
      //- }).catch(err => {
      //- })
    },
    goToHome () {
      this.$router.push('/')
    },
    goToPath (path, option) {
      this.search = ''
      //- this.eventLog({categoria: 'Vivemas', nombre: 'Cambio de sección', datos: {ruta: path, option}})
      if (path === '/vivemas') {
        this.$router.push(path)
      } else {
        this.categoryTitle = option
        //- this.page = 1
        //- this.skip = 0
        //- this.dataAssists = []
        this.getBenefitsCallback()
        let router = { name: 'AsistenciasVivemas' }
        if (option && option !== '') {
          router.query = { category: option }
          this.menuNav = []
          this.menuNav.push(...this.menuNavBase, {
            active: true,
            name: this.categoryTitle,
            path: '/vivemas-asistencias?category=' + this.categoryTitle,
            option: this.categoryTitle
          })
          this.gtmSend(option)
          //- this.$amplitude.getInstance()
          //-   .logEvent('Selección de Categoria', {'Tipo de Beneficio': 'Asistencias', 'Categoria': option, 'Canal de consulta': 'Zona Segura'})
          //- this.gtmChangeCategory('Asistencias', option)
          this.menuNav = this.menuNav.map(opt => {
            opt.active = opt.name === option
            return opt
          })
        } else {
          this.menuNav = []
          this.menuNav.push(...this.menuNavBase)
          this.menuNav = this.menuNav.map(opt => {
            opt.active = opt.name === 'Asistencias'
            return opt
          })
        }
        this.$router.push(router).catch(() => {})
      }
    },
    // EVENT - 53 -Elemento - Buscar - Analytics
    //- sendSearchAnalytics (counter, search) {
    //-   let resultado
    //-   if (counter > 0) {
    //-     resultado = 'Búsqueda con resultados'
    //-   } else {
    //-     resultado = 'Búsqueda sin resultados'
    //-   }
    //-   this.$gtm.trackEvent({
    //-     'event': 'virtualEvent',
    //-     'category': 'Zona Segura',
    //-     'action': 'Vive+ - Asistencias',
    //-     'label': 'Buscador - ' + resultado + ' - ' + search
    //-   })
    //-   this.$gtm.trackEvent({
    //-     'event': 'select_button',
    //-     'Nombre Sección': 'Zona Segura',
    //-     'TipoElemento': 'Botón',
    //-     'TipoAccion': 'Vive+ - Asistencias',
    //-     'CTA': 'Buscador - ' + resultado + ' - ' + search
    //-   })
    //- },
    registerGTM (UAT, GA4) {
      UAT.category = 'Zona Segura'
      GA4['Nombre Sección'] = 'Zona Segura'
      this.$gtm.trackEvent(UAT);
      this.$gtm.trackEvent(GA4);
    },
    // EVENT - 51 - Elemento - Cambiar Categorías - ANALYTICS
    gtmChangeCategory (nameCategory) {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Vive+ - Asistencia',
        'label': 'Seleccionar subcategoría - ' + nameCategory
      });
      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección':  'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Vive+ - Asistencia',
        'CTA':'Seleccionar subcategoría - ' + nameCategory
      });
      //- this.searchValidate = false
      //- this.searchPersistent = ''
    },
    // EVENT - 55  - Elemento - Ver más Servicios - ANALYTICS
    //- sendAnalityServicios (category) {
    //-   let categoryTitle
    //-   if (category === undefined || category === '') {
    //-     categoryTitle = 'Asistencias'
    //-   } else {
    //-     categoryTitle = category
    //-   }
    //-   this.$gtm.trackEvent({
    //-     'event': 'virtualEvent',
    //-     'category': 'Zona Segura',
    //-     'action': 'Vive+ - Asistencias',
    //-     'label': categoryTitle + ' - Seleccionar Botón Ver más'
    //-   })

    //-   this.$gtm.trackEvent({
    //-     'event': 'select_button',
    //-     'Nombre Sección': 'Zona Segura',
    //-     'TipoElemento': 'Botón',
    //-     'TipoAccion': 'Vive+ - Asistencias',
    //-     'CTA': categoryTitle + ' - Seleccionar Botón Ver más'
    //-   })
    //- },
    // EVENT - 56 - Elemento - Seleccionar detalles del servicio
    //- gtmSelectDetails (category, item) {
    //-   let categoryTitle
    //-   if (category === undefined || category === '') {
    //-     categoryTitle = 'Asistencias'
    //-   } else {
    //-     categoryTitle = 'Asistencias - ' + category
    //-   }
    //-   this.$gtm.trackEvent({
    //-     'event': 'virtualEvent',
    //-     'category': 'Zona Segura',
    //-     'action': 'Vive+ - ' + categoryTitle,
    //-     'label': item.name + ' - Seleccionar detalles'
    //-   })

    //-   this.$gtm.trackEvent({
    //-     'event': 'select_button',
    //-     'Nombre Sección': 'Zona Segura',
    //-     'TipoElemento': 'Botón',
    //-     'TipoAccion': 'Vive+ - ' + categoryTitle,
    //-     'CTA': item.name + ' - Seleccionar detalles'
    //-   })
    //- },
    //- inputSearchData (evt) {
    //-   this.search = evt.target.value
    //- },
    filterData (evt, category) {
      evt.preventDefault()
      this.categoryTitle = ''
      this.search = evt.target.value
      if (evt.key === 'Enter') {
        this.gtmSearch('Asistencias', this.search, category)
        this.getBenefitsCallback()
        //- this.page = 1
        //- this.skip = 0
        //- this.dataAssists = []
      }
    },
    //- nextData () {
    //-   this.page += 1
    //-   this.skip = (this.page - 1) * this.limit
    //-   this.getBenefitsCallback()
    //-   this.sendAnalityServicios(this.categoryTitle)
    //- },
    //- getPaymentType (option) {
    //-   switch (option) {
    //-   case 'copago':
    //-     return 'Copago'
    //-   case 'discount':
    //-     return 'Descuento'
    //-   case 'free':
    //-     return 'Gratis'
    //-   default:
    //-     return 'Descuento'
    //-   }
    //- },
    gtmBtn (nameCategory) {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Vive+ - Asistencia',
        'label': 'Seleccionar botón - Ver más  - ' + nameCategory
      });
      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección':  'Zona Segura',
        'TipoElemento': 'Ícono- Botón',
        'TipoAccion': 'Vive+ - Asistencia',
        'CTA':'Seleccionar botón - Ver más  - ' + nameCategory
      });
    },
    gtmSend (path) {
      this.$gtm.trackEvent({
        event: 'virtualPage',
        pageName: path,
        pagePath: '/zona-segura/vivemas/asistencias-' + this.removeAcents(path.toLowerCase().split(' y ').join(' ').split(' de ').join(' ')).split(' ').join('-')
      })
      this.$gtm.trackEvent({
        event: 'virtualPage',
        pageName: path,
        pagePath: '/vivemas/asistencias-' + this.removeAcents(path.toLowerCase().split(' y ').join(' ').split(' de ').join(' ')).split(' ').join('-')
      })
    },
    gtmSearch (beneficio, search, category) {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Vive+ - ' + beneficio,
        'label': 'Buscador - ' + search,
        'dimension27' : category
      });
      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección':  'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Vive+ - ' + beneficio,
        'CTA': 'Buscador - ' + search,
        'SubCategoría': category
      });
    },
    removeAcents (cadena) {
      const acentos = {'%': '', 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U'}
      return cadena.split('').map(letra => acentos[letra] || letra).join('').toString()
    }
  },
  computed: {
    ...mapGetters('vivemas', ['assistCategories', 'assists']),
    ...mapGetters('user', ['basicInfo'])
  },
  created () {
    let products = localStorage.getItem('products')
    if (products && products !== null) {
      this.productsArray = JSON.parse(products).map(p => p.toLowerCase())
      this.isOnlySoat = this.productsArray.length === 1 && this.productsArray.includes('soat')
    }
    if (this.isOnlySoat) {
      this.$router.push({ name: 'DescuentosVivemas' }).catch(() => {})
    }
  },
  
}
</script>
<style>
  @import url('../assets/css/general.css');
    article.g-flex.g-align-center {
      margin-left: 15px;
  }

  .list-category h3 {
    color: #535D66;
    margin-bottom: 25px;
    margin-top: -10px;
  }

  .v-tooltip__content {
    background: #454A6C;
  }

  .modal-detalle-item-content .g-flex p a {
    font-size: 14px;
  }

  .selected-box {
    border-color: #0855c4 !important;
  }
  .g-flex.justify-space-between.align-center.mt-3.tooltip-payment-type .v-tooltip.v-tooltip--bottom .v-tooltip__content {
    right: -3em !important;
    top: 9em !important;
    left: auto !important;
  }

  .g-flex.justify-space-between.align-center.mt-3.tooltip-limit .v-tooltip.v-tooltip--bottom .v-tooltip__content {
    right: -2em !important;
    top: 11em !important;
    left: auto !important;
  }

  span.title_back_solicitudes {
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/pages/LandingAsistencia.vue